<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-09 21:00:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/search/components/SearchFind/index.vue
-->
<template>
  <div class="his_list">
    <div class="top_title">
      <div class="font14 font_weight500 colo087">搜索发现</div>
    </div>
    <div class="list">
      <div
        v-for="(i, index) in searchFoundList"
        :key="index"
        :class="index % 2 === 0 ? 'list_item1' : 'list_item2'"
        class="font12 font_weight400 colo087 list_item"
        @click="clickHistoryItem(i)"
      >
        {{ i }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    searchFoundList() {
      return this.$store.getters.searchFoundList;
    }
  },
  data() {
    return {};
  },
  methods: {
    clickHistoryItem(keywords) {
      this.$emit("clickHistoryItem", keywords);
    }
  }
};
</script>
<style lang="less" scoped>
.his_list {
  padding: 10px 12px 0;
  background: #fff;
  .top_title {
    display: flex;
    justify-content: space-between;
  }
  .del_icon {
    width: 16px;
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 18px 12px 0;
    .list_item {
      width: 150px;
      text-align: center;
      background: #f4f5f9;
      border-radius: 2px;
      line-height: 30px;
    }
    .list_item1 {
      margin: 0 19px 8px 0;
    }
    .list_item2 {
      margin: 0 0 8px 0;
    }
  }
}
</style>
